import http from 'plugins/axios'

export default {
  getTradeStatistic(data) {
    return http.get({
      url: `/ta/admin/channel/getTradeStatistic`,
      data,
    })
  },
  tradeCharts(data) {
    return http.post({
      url: `/ta/admin/channel/trade/charts`,
      data,
    })
  },

  topChannelList(data) {
    return http.get({
      url: `/ta/admin/channel/common/topChannelList`,
      data,
    })
  },
  userTradeInfo(data) {
    return http.get({
      url: `/ta/admin/channel/tiger/userTradeInfo`,
      data,
    })
  },
  // 充提记录
  getRecords(data) {
    return http.get({
      url: `/ta/admin/tenant/workorder/search_deposit`,
      data,
    })
  },
  // 充提汇总
  getRecordsTotal(data) {
    return http.get({
      url: `/ta/admin/tenant/workorder/search_deposit_total`,
      data,
    })
  },
  //数据汇总
  getTradeStatisticTotal(data) {
    return http.get({
      url: `/ta/admin/channel/getTradeStatistic/total`,
      data,
    })
  },
  // 资金费用
  getFund(data) {
    return http.get({
      url: `/ta/admin/tenant/fund-rate-record/list`,
      data,
    })
  },
  // 资金明细
  getFundDetail(data) {
    return http.get({
      url: `/ta/admin/tenant/fund-rate-record/detail-list`,
      data,
    })
  },
  //获取交易对列表
  getSymbolList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'CONTRACT' },
    })
  },
}
